module.exports = __webpack_public_path__ + "img/TOURS.df0ba1b0.jpg";